import React, {useState} from 'react';
import Picture from '../../components/Picture';
import {CLANS_BY_ID} from '../data/clans';
import {localized} from '../data/traits';
import {CHARACTER_STATUS} from '../character';
import {vtmT} from '../i18n';

const MAX_AVATARS = 3;

/**
 * Bouton « Coterie » de l'en-tête de fiche : portraits empilés, liste au survol (ou au clic / focus).
 * Nom, portrait et clan des PJ de la campagne, sans leurs stats ; les brouillons sont masqués.
 */
const VtmCoterie = ({characters, currentUid, lng}) => {
  const [open, setOpen] = useState(false);
  const members = characters
    .filter(character => character.status !== CHARACTER_STATUS.DRAFT)
    .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  if (members.length === 0) return null;

  return (
    <div
      className="vtmCoterie"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onBlur={event => {
        if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
      }}
      onKeyDown={event => {
        if (event.key === 'Escape') setOpen(false);
      }}
    >
      <button
        type="button"
        className="vtmCoterieButton"
        aria-expanded={open}
        aria-controls="vtmCoteriePopover"
        onClick={() => setOpen(!open)}
        onFocus={() => setOpen(true)}
      >
        <span className="vtmCoterieAvatars" aria-hidden="true">
          {members.slice(0, MAX_AVATARS).map(character => (
            <span key={character.uid} className="vtmCoterieAvatar"><Picture character={character} /></span>
          ))}
        </span>
        <span className="vtmCoterieButtonLabel">{vtmT('coterie')} · {members.length}</span>
      </button>
      {open && (
        <div id="vtmCoteriePopover" className="vtmCoteriePopover">
          <ul className="vtmCoterieList">
            {members.map(character => (
              <li key={character.uid} className={`vtmCoterieMember${character.uid === currentUid ? ' current' : ''}`}>
                <span className="vtmCoteriePortrait"><Picture character={character} /></span>
                <span className="vtmCoterieIdentity">
                  <span className="vtmCoterieName">{character.name}</span>
                  <span className="vtmCoterieClan">{localized(CLANS_BY_ID[character.vtm?.clan]?.name, lng) || '—'}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default VtmCoterie;
